export default "__VITE_ASSET__B3Cf0CCg__"